import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { Button } from '../../../components/Button';

export const StyledContactUsExportOption = styled.div`
  background-color: ${colorsPalettes.sky[100]};
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 10px 16px;
  ${setFontVariant('body2', colorsPalettes.indigo[300])};
`;

export const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 128px;
`;
